<template>
    <OfflineTicket
        :ticket="modalData.ticket"
        :isSubmit="modalData.isSubmit"
        @close="$emit('close')"
    />
</template>

<script>
    import { mapGetters } from 'vuex';
    import OfflineTicket from '@shared/tickets/OfflineTicket';

    export default {
        computed: {
            ...mapGetters('ui/modal', [
                'modalData',
            ]),
        },
        components: {
            OfflineTicket,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/singleTicket/SingleTicketModal.vue